import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

class TextListCell extends PureComponent<IGridCellRenderProps<string[]>> {
    render() {
        const { cellValue } = this.props;
        if (!cellValue) {
            return null;
        }

        return cellValue.map((x, i) =>
            /* It's okay to use the index as the key here because dynamic grid column data won't be
             * reordered unless we do a new API call, which will rerender the component anyway.
             *
             * We can't use the text itself as the key, because it might not be unique (eg,
             * shared phone numbers between owners of the same household). And there isn't any other
             * data like an ID to use as the key instead; it's just a string.
             */
            // prettier-ignore
            <TextTruncate key={i} style={{ minHeight: "2rem" }}>{/* NOSONAR */}
                {x}
            </TextTruncate>,
        );
    }
}

export const columnTextList: IClientGridColumn<string[]> = {
    columnType: GridColumnType.textList,
    Cell: TextListCell,
};
